import React from "react";
import { Modal, ModalBody } from "reactstrap";
import Sheet_img from "../../../assets/images/example_excel_sheet.png";
import excel_template from "../../../assets/files/products.xlsx";

interface props {
  show: boolean;
  onCloseClick: any;
  msg?: string;
}

export const ExampleFileModal = ({
  show,
  onCloseClick,
  msg = "Please ensure your file follows this format or download the starter template below to get started.",
}: props) => {
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = excel_template; // URL of the image
    link.download = "products.xlsx"; // Name of the downloaded file
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Modal isOpen={show} toggle={onCloseClick} centered={true} size="xl">
      <div className="modal-content">
        <ModalBody className="px-4 py-5 text-center">
          <button
            type="button"
            onClick={onCloseClick}
            className="btn-close position-absolute end-0 top-0 m-3"
          ></button>
          <img
            className="img-fluid rounded d-block"
            src={Sheet_img}
            alt="alt"
            style={{ objectFit: "cover", width: "100%", height: "100%" }}
          />

          <p className="text-muted font-size-14 mt-4 mb-4">{msg}</p>

          <div className="hstack gap-2 justify-content-center mb-0">
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleDownload}
            >
              Download template
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onCloseClick}
            >
              Close
            </button>
          </div>
        </ModalBody>
      </div>
    </Modal>
  );
};
